/**
 * @author       Digitsensitive <digit.sensitivee@gmail.com>
 * @copyright    2018 - 2019 digitsensitive
 * @license      {@link https://github.com/digitsensitive/phaser3-typescript/blob/master/LICENSE.md | MIT License}
 */
import 'phaser';

import {BootScene} from './scenes/boot-scene';
import {MenuScene} from './scenes/menu-scene';
import {GameScene} from './scenes/game-scene';
import {ScorePanelScene} from './scenes/score-panel-scene';
import 'phaserPlugins/spine/dist/SpinePlugin';
import './common/responsive';
import './assets/scss/main.scss';
import AudioManager from './objects/audioManager';
import * as Sentry from './sentry';

Sentry.init();

// main game configuration
const config: Phaser.Types.Core.GameConfig = {
    width: 1280,
    height: 960,
    url: 'https://www.burometa.nl',
    version: '1.0',
    // zoom: 3,
    type: Phaser.AUTO,
    parent: 'game',
    scene: [BootScene, MenuScene, GameScene, ScorePanelScene],
    plugins: {
        scene: [
            {
                key: 'SpinePlugin',
                plugin: window.SpinePlugin,
                mapping: 'spine',
            },
        ],
        global: [
            {key: 'AudioManager', plugin: AudioManager, start: false, sceneKey: 'audioManager'},
        ],
    },
    input: {
        keyboard: true,
        mouse: true,
    },
    render: {
        transparent: true,
    },
};

export class Game extends Phaser.Game {
    constructor(cfg: Phaser.Types.Core.GameConfig) {
        super(cfg);
    }
}

/**
 * Check if the encoded parameter is a correct token
 *
 * @param encoded
 */
function isValid(encoded) {
    try {
        const decoded = JSON.parse(atob(encoded));
        const d1 = new Date(decoded.timestamp);
        const d2 = new Date();

        if (d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate() &&
            decoded.unlocked &&
            (decoded.level ?? '') === 'rood'
        ) {
            return true;
        }
        return false;
    } catch(error)
    {
        return false;
    }
}

/**
 * Return the value of the querystring parameter name.
 *
 * @param name
 * @param url
 */
function getParameterByName(name: string, url?) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// when the page is loaded, create our game instance
window.addEventListener('load', () => {
    if (process.env.NODE_ENV === 'production') {
        const token = getParameterByName('token');
        if (!token || !isValid(token)) {
            console.error('Incorrect token value specified!');
            return;
        }
    }

    new Game(config);

    // trigger resize (maybe better later? when game is loaded?)
    window.dispatchEvent(new Event('resize'));
});






